import { render, staticRenderFns } from "./SideBarNew.vue?vue&type=template&id=bb8b11fc&scoped=true"
import script from "./SideBarNew.vue?vue&type=script&lang=js"
export * from "./SideBarNew.vue?vue&type=script&lang=js"
import style0 from "./SideBarNew.vue?vue&type=style&index=0&id=bb8b11fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8b11fc",
  null
  
)

export default component.exports